export default "__VITE_ASSET__DqbWk65m__"